{
  "dataTable": {
    "view": "Affichage",
    "columns": "Colonnes",
    "rowsSelected_one": "{{count}} sur {{total}} ligne sélectionnée",
    "rowsSelected_other": "{{count}} sur {{total}} lignes sélectionnées",
    "totalResults_one": "{{count}} résultat",
    "totalResults_other": "{{count}} résultats",
    "filteredResults_one": "{{filtered}} sur {{total}} résultat",
    "filteredResults_other": "{{filtered}} sur {{total}} résultats",
    "rowsPerPage": "Lignes par page",
    "page": "Page {{current}} sur {{total}}",
    "noResults": "Aucun résultat.",
    "noResultsFound": "Aucun résultat trouvé.",
    "pagination": {
      "goToFirstPage": "Aller à la première page",
      "goToPreviousPage": "Aller à la page précédente",
      "goToNextPage": "Aller à la page suivante",
      "goToLastPage": "Aller à la dernière page"
    },
    "search": "Rechercher...",
    "filterValuePlaceholder": "Saisir {{label}}...",
    "selectPlaceholder": "Sélectionner...",
    "sortAscending": "Tri croissant",
    "sortDescending": "Tri décroissant",
    "sortThenAscending": "Puis croissant",
    "sortThenDescending": "Puis décroissant",
    "sortRank": "Ordre de tri {{rank}}",
    "clearSort": "Effacer le tri",
    "addFilter": "Ajouter un filtre",
    "clearFilter": "Effacer le filtre",
    "hideColumn": "Masquer la colonne",
    "filtered": "Filtré",
    "groupBy": "Grouper par {{label}}",
    "filters": {
      "searchPlaceholder": "Rechercher...",
      "selectPlaceholder": "Sélectionner...",
      "all": "Tout",
      "from": "De",
      "to": "À",
      "min": "Min",
      "max": "Max",
      "activeFilters": "Filtres actifs",
      "clearAll": "Tout effacer",
      "removeFilter": "Supprimer le filtre"
    },
    "resetColumns": "Rétablir par défaut"
  }
}
